// Company Helpers

export const isIHG = tags => Array.isArray(tags) && tags.some(tag => tag.tagId === 9);

